
import { defineComponent } from "vue";

export default defineComponent({
  name: "NjButton",
  inheritAttrs: false,
});
